import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/store.js'

Vue.use(VueRouter)

import VehicleNewPolicy             from '../components/VehicleNewPolicy.vue'

import VehiclePlate                 from '../components/panels/new/VehiclePlate.vue'
import VehicleConfirm               from '../components/panels/new/VehicleConfirm.vue'
import VehicleDriverDetails         from '../components/panels/new/VehicleDriverDetails.vue'
import VehicleQuote                 from '../components/panels/new/VehicleQuote.vue'
import VehicleDetails               from '../components/panels/new/VehicleDetails.vue'
import VehicleDriverClaimHistory    from '../components/panels/new/VehicleDriverClaimHistory.vue'
import VehicleCreateAccount         from '../components/panels/new/VehicleCreateAccount.vue'
import VehicleDeclaration           from '../components/panels/new/VehicleDeclaration.vue'
import VehiclePayment               from '../components/panels/new/VehiclePayment.vue'
import VehicleSorry                 from '../components/panels/new/VehicleSorry.vue'
import VehicleSuccess               from '../components/panels/new/VehicleSuccess.vue'

import VehicleCancelPolicy          from '../components/cancel/VehicleCancelPolicy.vue'
import VehicleCancelConfirm         from '../components/panels/cancel/VehicleCancelConfirm.vue'

import VehicleRestorePolicy         from '../components/restore/VehicleRestorePolicy.vue'

import VehicleAltPolicy             from '../components/alt/VehicleAltPolicy.vue'
import VehicleAltConfirm            from '../components/panels/alt/VehicleConfirm.vue'
import VehicleAltQuote              from '../components/panels/alt/VehicleQuote.vue'
import VehicleAltPayment            from '../components/panels/alt/VehiclePayment.vue'
import VehicleAltSuccess            from '../components/panels/alt/VehicleSuccess.vue'

import VehicleRenewPolicy           from '../components/renew/VehicleRenewPolicy.vue'
import VehicleRenewConfirm          from '../components/panels/renew/VehicleConfirm.vue'
import VehicleRenewQuote            from '../components/panels/renew/VehicleQuote.vue'
import VehicleRenewDeclaration      from '../components/panels/renew/VehicleDeclaration.vue'
import VehicleRenewPayment          from '../components/panels/renew/VehiclePayment.vue'
import VehicleRenewSuccess          from '../components/panels/renew/VehicleSuccess.vue'


import NotFound                     from '../components/NotFound.vue'
import VueGtag from "vue-gtag";

const routes = [
    {
        path: '/vehicle/new',
        name: 'Vehicle',
        component: VehicleNewPolicy,
        children: [
        {
            path: 'plate',
            component: VehiclePlate
        },
        {
            name: "Vehicle.Plate",
            path: 'plate/:session_id',
            component: VehiclePlate
        },
        {
            name: "Vehicle.Confirm",
            path: 'confirm/:session_id',
            component: VehicleConfirm
        },
        { 
            name: "Vehicle.Quote",
            path: 'quote/:session_id',
            component: VehicleQuote
        },
        { 
            name: "Vehicle.Details",
            path: 'details/:session_id',
            component: VehicleDetails
        },
        { 
            name: "Vehicle.DriverDetails",
            path: 'driver-details/:session_id',
            component: VehicleDriverDetails
        },
        { 
            name: "Vehicle.DriverClaimHistory",
            path: 'driver-claim-history/:session_id',
            component: VehicleDriverClaimHistory
        },
        {
            name: "Vehicle.CreateAccount",
            path: 'create-account/:session_id',
            component: VehicleCreateAccount
        },
        { 
            name: "Vehicle.Declaration",
            path: 'declaration/:session_id',
            component: VehicleDeclaration
        },
        { 
            name: "Vehicle.Payment",
            path: 'payment/:session_id',
            component: VehiclePayment
        },
        { 
            name: "Vehicle.Sorry",
            path: 'sorry/:session_id',
            component: VehicleSorry
        },
        {
            name: "Vehicle.Success",
            path: 'success/:session_id',
            component: VehicleSuccess
        }
        ]
    },
    {
        path: '/vehicle/cancel',
        name: 'VehicleCancel',
        component: VehicleCancelPolicy,
        children: [
            {
                path: 'confirm',
                component: VehicleCancelConfirm
            }
        ]
    },
    {
        path: '/vehicle/restore',
        name: 'VehicleRestore',
        component: VehicleRestorePolicy,
    },
    {
        path: '/vehicle/alt/:policy_id',
        name: 'VehicleAlt',
        component: VehicleAltPolicy,
        children: [
            {
                name: "VehicleAlt.Confirm",
                path: 'confirm/:session_id',
                component: VehicleAltConfirm
            },
            {
                name: "VehicleAlt.Payment",
                path: 'payment/:session_id',
                component: VehicleAltPayment
            },
            {
                name: "VehicleAlt.Quote",
                path: 'quote/:session_id',
                component: VehicleAltQuote
            },
            {
                name: "VehicleAlt.Success",
                path: 'success/:session_id',
                component: VehicleAltSuccess
            }
        ]
    },
    {
        path: '/vehicle/renew/:policy_id',
        name: 'VehicleRenew',
        component: VehicleRenewPolicy,
        children: [
            {
                name: "VehicleRenew.Confirm",
                path: 'confirm/:session_id',
                component: VehicleRenewConfirm
            },
            {
                name: "VehicleRenew.Payment",
                path: 'payment/:session_id',
                component: VehicleRenewPayment
            },
            {
                name: "VehicleRenew.Declaration",
                path: 'declaration/:session_id',
                component: VehicleRenewDeclaration
            },
            {
                name: "VehicleRenew.Quote",
                path: 'quote/:session_id',
                component: VehicleRenewQuote
            },
            {
                name: "VehicleRenew.Success",
                path: 'success/:session_id',
                component: VehicleRenewSuccess
            }
        ]
    },

    { path: '*', component: NotFound },
]

const router = new VueRouter({
    routes,
    mode: 'history',
    base: "/spa/",
    scrollBehavior() {
        document.getElementById('app').scrollIntoView({ behavior: 'smooth' });
    },
})

// We don't boostrap the google tag as we ajax the correct id ( based on env )
// in within the app.vue
Vue.use(VueGtag, {
    // config: { id: "UA-1234567-1" }
    bootstrap: false,
    pageTrackerTemplate(to) {
        const base_no_trailing_slash = router.options.base.endsWith('/') ? router.options.base.slice(0, -1) : router.options.base;
        const page_path_with_base = base_no_trailing_slash + to.path;
        return {
            page_path: page_path_with_base,
            page_location: window.location.href,
            page_title: to.name,
        }
    }
}, router);

// TODO: clean up a bunch of logging

router.beforeEach((to,from,next) => {

    // console.group('BEFORE ROUTER GUARD');
    // console.log(' === BEFORE EACH ROUTER GUARD ===');
    // console.log('session_id',from.params.session_id);

    // console.warn('session_id: ', to.params.session_id);
    // console.log( '%csession_id: ' + to.params.session_id, 'background: #222; color: lightgreen' );

    if (to.params.session_id) {

        // console.log('%cinitSession', 'background: #222; color: pink');

        store.commit('initSession', to.params.session_id);
        // console.group();
        // console.log(from);
        // console.groupEnd();

        store.commit('setActiveStep',to.name);

        // setup initial stepPath
        if ( store.getters.currentSession.stepPath === undefined || store.getters.currentSession.stepPath.length === 0) {
            store.getters.currentSession.stepPath = [ to.name ];
        }
    }

    // console.log('currentSession',store.getters.currentSession);

    if ( ( from.params?.session_id ?? false === false ) && ( store.getters.currentSession.schema_version === 0 ) ) {
        // from.params.session_id is set (not false) *after* initial form start /spa/vehicle/new,
        // after then we should be aware of schema_version
        // outsiders that do not have schema_version set correctly and try to navigate directly to /spa/vehicle/<step>/<session_id> will be redirected
        // this is to stop the form being rendered (with errors) to a vulnerability scan / scraper

        const cli_num_or_unknown = store.client ? store.client.cli_num : 'unknown';

        window.location.href = `/app/spa-issue/vehicle?response-code=404&schema-version=0&uuid=${ store.getters.getSessionId() }&cli_num=${cli_num_or_unknown}`;
        return;
    }

    if (store.getters.currentSession.stepPath) {
        // only allow success page if form completed
        let step = store.getters.currentSession.stepPath.slice(-1)[0];

        if ( step.split(".")[1] == 'Success') {
            if (to.name.split(".")[1] == 'Success') {
                // stepPath has success, let this through
                // console.error( 'NEXT' );
                next();
                return;
            }
            let successStep = step.split(".")[0] + '.Success'

            // trying to go back from success page, redirect to success
            next({ name: successStep, params: { session_id: to.params.session_id } });
            return;
        }

        // find current step in stepPath
        let currentStepIndex = store.getters.currentSession.stepPath.findIndex(k => k === to.name);
        
        // find requested step in all routes
        let requestedStepIndex = routes[0].children.findIndex(k => k.name === to.name);

        // console.error( 'to.name: ', to.name );
        // console.error( 'stepPath: ', store.getters.currentSession.stepPath );

        // console.log('%ccurrentStepIndex: ' + currentStepIndex, 'background: #222; color: yellow');
        // console.log('%crequestedStepIndex: ' + requestedStepIndex, 'background: #222; color: lightblue');

        if ( currentStepIndex >= 0 ) {
            // going back in the form, remove now invalid pages from stepPath and continue to desired page
            store.getters.currentSession.stepPath = store.getters.currentSession.stepPath.slice(0,currentStepIndex+1);
            next();
            return;
        } else if ( requestedStepIndex >= 0 ) {
            // found valid route, but not form state doesn't have route
            // trying to go forward in the form, force to latest verified step instead

            // current validated route + 1
            let validRouteIndex = routes[0].children.findIndex(k => k.name === store.getters.currentSession.stepPath.slice(-1)[0]);

            next({ name: routes[0].children[validRouteIndex].name, params: { session_id: to.params.session_id } });
            return;
        } else {
            // trying to go to panels that don't exist

            // just go to dashboard
            // console.error('WE SHOULDNT BE HERE, GO TO DASHBOARD');
            window.location = '/app/member/dashboard';
            return;

            // console.error(' WE SHOULDNT BE HERE, go back to: ', store.getters.currentSession.stepPath.slice(-1)[0]);
            // //.push({name: this.currentSession.stepPath.slice(-1) });
            // //router.push({ name: store.getters.currentSession.stepPath.slice(-1) });
            // store.commit('setActiveStep',store.getters.currentSession.stepPath.slice(-1)[0]);
            // next({ name: store.getters.currentSession.stepPath.slice(-1)[0] });
        }
    } else {
        // we get here prior to setting up a brand new quote, just continue
        // console.error( 'NEXT' );
        next();
        return;
    }
    // console.log(' === /BEFORE EACH ROUTER GUARD ===');
    // console.groupEnd();
});

router.afterEach((to) => {
    // console.group('After router guard');
    // console.log('to: ',to);

    // console.log('activeStepKey: ',store.getters.currentSession.activeStepKey);

    if ( store.state.session_id == null ) {

        // this catches when the url has the session id, but the store is unaware
        if ( to.params.session_id ) {
            // console.log('BROWSER REFRESH');

            // console.log( to.params )

            store.commit('initSession',to.params.session_id);
            // store.commit('setActiveStep',to.name);
        }

        // What happens if there is no session id ?
        //
    }


    // store.commit('setActiveStep',to.name);

    // check problems with history when stepping back/forward with browser buttons
    // console.log('stepPath: ',store.getters.currentSession.stepPath);
    // console.log(to.name);
    // console.log('activeStepKey: ',store.getters.currentSession.activeStepKey);

    // // find current step in stepPath
    // let i = store.getters.currentSession.stepPath.findIndex(k => k==to.name);
    // console.log(i);
    // if ( i >= 0 ) {
    //     // remove 
    //     store.getters.currentSession.stepPath = store.getters.currentSession.stepPath.slice(0,i+1);
    //     console.log('findIndex: ',i);
    // } else {
    //     // should we be here?
    //     console.log('SHOULD WE BE HERE?');
    //     //.push({name: this.currentSession.stepPath.slice(-1) });
    //     router.push({ name: store.getters.currentSession.stepPath.slice(-1) });
    // }
    // console.groupEnd();

})

export default router